// extracted by mini-css-extract-plugin
module.exports = {"modal":"accountPropertiesModal_modal__X5n64","headerContent":"accountPropertiesModal_headerContent__x85F9"};